const EyeSparkle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4.58334C7.30737 4.58332 4.53111 6.18898 2.60162 9.57502C2.45148 9.8385 2.45148 10.1614 2.60162 10.4248C4.53111 13.8109 7.30738 15.4166 10 15.4166C12.6927 15.4166 15.469 13.811 17.3984 10.4249C17.5486 10.1615 17.5486 9.83859 17.3984 9.57511C15.469 6.18907 12.6927 4.58336 10 4.58334ZM10 3.33334C13.2326 3.33337 16.3816 5.2659 18.4845 8.95624C18.8532 9.60335 18.8532 10.3967 18.4845 11.0438C16.3816 14.7342 13.2326 16.6666 10 16.6666C6.76744 16.6666 3.61846 14.7341 1.51557 11.0437C1.14683 10.3966 1.14683 9.60325 1.51557 8.95615C3.61847 5.26581 6.76744 3.33332 10 3.33334Z"
        fill="currentColor"
      />
      <path
        d="M8.95103 8.76467L9.62735 7.41203C9.7809 7.10493 10.2192 7.10493 10.3727 7.41203L11.049 8.76467C11.0893 8.84531 11.1547 8.91069 11.2354 8.95101L12.588 9.62733C12.8951 9.78088 12.8951 10.2191 12.588 10.3727L11.2354 11.049C11.1547 11.0893 11.0893 11.1547 11.049 11.2353L10.3727 12.588C10.2192 12.8951 9.7809 12.8951 9.62735 12.588L8.95103 11.2353C8.91071 11.1547 8.84533 11.0893 8.76469 11.049L7.41205 10.3727C7.10495 10.2191 7.10495 9.78088 7.41205 9.62733L8.76469 8.95101C8.84533 8.91069 8.91071 8.84531 8.95103 8.76467Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default EyeSparkle
